import { Backdrop, Box, CircularProgress } from '@mui/material';
import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ConsumerBaseLoading from '../../components/consumerBase/ConsumerBaseLoading';
import CurrentBillingChartLoading from '../../components/currentBillingChart/CurrentBillingChartLoading';
import CurrentCollectionDashboardLoading from '../../components/currentCollectionChart/CurrentCollectionChartLoading';
import JuniorCardLoading from '../../components/juniorCard/JuniorCardLoading';
import TechnicalAndCommercialLoading from '../../components/technicalAndCommercial/TechnicalAndCommercialLoading';
import trendingUpIcn from '../../images/dashboard/green_arrow_icon.png';
import trendingDownIcn from '../../images/dashboard/red_arrow_icon.png';
import { cfpBaseUrl } from '../../network/urls';
import { calculateATCMainFigure, calculateRecoveryMainFigure, calculateTDMainFigure, getChildLevel, getName, getParentLevel, getTrendingIcon, groupByOfficeCode, numberFormatting, separateObjectsByYear, transformData } from '../../services/Functions';
import { updatePerformance } from '../../features/dashboard/overallPerformance';
import { updateOC } from '../../features/officeCodeForName/officeCodeForName';
const JuniorCard = React.lazy(() => import('../../components/juniorCard/JuniorCard'));
const ConsumerBase = React.lazy(() => import('../../components/consumerBase/ConsumerBase'));
const CurrentCollectionDashboard = React.lazy(() => import('../../components/currentCollectionChart/CurrentCollectionChart'));
const TechnicalAndCommercial = React.lazy(() => import('../../components/technicalAndCommercial/TechnicalAndCommercial'));
const CurrentBillingChart = React.lazy(() => import('../../components/currentBillingChart/CurrentBillingChart')); // Adjust the path based on your project structure

const HierarchicalDashboard = () => {
    const { code } = useSelector(state => state.auth);
    const location = useLocation();
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [officeCode, setOfficeCode] = useState(code)
    const { token, hierarchy } = useSelector((state) => state.auth)
    const dispatch = useDispatch()
    let subdivisionsFromLocalStorage = JSON.parse(window.localStorage.getItem('subDivisions'));

    useEffect(() => {
        dispatch(updateOC({ officeCode: code }))
    }, [])

    useEffect(() => {
        if (location.state && location.state.officeCode) {
            let officeCode = location.state.officeCode.toString(); // Provide a default value if needed
            officeCode = officeCode == "10" ? "15" : officeCode
            setOfficeCode(officeCode)
        } else {
            setOfficeCode(code)
        }
    }, [location])

    const updateOfficeCode = (code) => {
        if (code) {
            setOfficeCode(code)
            dispatch(updateOC({ officeCode: code }))
        }
    }

    //#region previous dashboard logic

    const drillUp = (loweritem) => {
        let codeOfUpperItem = loweritem.code.toString().slice(0, loweritem.code.toString().length - 1)
        const fetchData = async () => {
            setViewBackdrop(true)
            try {

                //#region Customer Services
                let newConnectionResult = await NewConnectionsStats(codeOfUpperItem)
                let complaintsResult = await ComplaintsStats(codeOfUpperItem)
                let cp90Result = await DefectiveCP90DashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
                //#endregion

                let tdMonthlyLossesResult = await MonthlyTDLossesDashboardStatsDrillUp(token, parseInt(codeOfUpperItem), loweritem.level - 1);
                let tdProgressiveLossesResult = await ProgressiveTDLossesDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
                let recoveryMonthlyResult = await MonthlyRecoveryDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
                let recoveryProgressiveResult = await ProgressiveRecoveryDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
                let atcMonthlyResult = await MonthlyATCDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
                let atcProgressiveResult = await ProgressiveATCDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))

                if (loweritem.level === 3) {
                    let allCircles = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
                    let responseUniqueCodesWithName = [];
                    allCircles.forEach(item => {
                        let object = {};
                        object.code = item;
                        let obj = {}
                        if (subdivisionsFromLocalStorage) {
                            obj = subdivisionsFromLocalStorage.find(itm => itm.circleCode === item);
                        }
                        object.name = obj ? obj.circleName : null;
                        object.level = parseInt(loweritem.level);
                        object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
                        object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
                        object.drillFunction = drillDown
                        object.tableDataServices = []

                        let ncData = newConnectionResult.find((item) => item.officeCode == object.code)
                        if (ncData) {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: ncData.Ripe,
                                unripe: ncData.Unripe,
                                total: ncData.Ripe + ncData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let complaintData = complaintsResult.find((item) => item.OfficeCode == object.code)
                        if (complaintData) {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: complaintData.Ripe,
                                unripe: complaintData.Unripe,
                                total: complaintData.Ripe + complaintData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
                        if (cp90Data) {
                            object.tableDataServices.push(
                                {
                                    type: 'Defective Meter (CP-90)',
                                    pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                                    attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                                    total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                                    cp90MetersData: cp90Data.defectiveMetersData,
                                    replacedPercent: cp90Data.replacedPercent,
                                    pendingPercent: cp90Data.pendingPercent
                                },
                            )
                        }

                        object.tableDataTechnical = []

                        let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

                        if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'T & D',
                                    monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                                    progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                                    tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                                    tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                                    tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                                    tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                                },
                            )
                        }

                        let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'Recovery',
                                    monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                                    progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                                    recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                                    recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                                    recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                                    recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                                }
                            )
                        }

                        let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'AT & C',
                                    monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                                    progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                                    atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                                    atcMonthlyDifferenceData: atcMonthlyData.incDec,
                                    atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                                    atcProgressiveDifferenceData: atcProgressiveData.incDec,
                                },
                            )
                        }
                        responseUniqueCodesWithName.push(object);
                    })
                    setChildrenList(responseUniqueCodesWithName)
                }
                if (loweritem.level === 4) {
                    let allDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
                    let responseUniqueCodesWithName = [];
                    allDivisions.forEach(item => {
                        let object = {};
                        object.code = item;
                        let obj = {}
                        if (subdivisionsFromLocalStorage) {
                            obj = subdivisionsFromLocalStorage.find(itm => itm.divisionCode === item);
                        }
                        object.name = obj ? obj.divisionName : null;
                        object.level = parseInt(loweritem.level);
                        object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
                        object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
                        object.drillFunction = drillDown
                        object.tableDataServices = []

                        let ncData = newConnectionResult.find((item) => item.officeCode == object.code)
                        if (ncData) {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: ncData.Ripe,
                                unripe: ncData.Unripe,
                                total: ncData.Ripe + ncData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let complaintData = complaintsResult.find((item) => item.OfficeCode == object.code)
                        if (complaintData) {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: complaintData.Ripe,
                                unripe: complaintData.Unripe,
                                total: complaintData.Ripe + complaintData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
                        if (cp90Data) {
                            object.tableDataServices.push(
                                {
                                    type: 'Defective Meter (CP-90)',
                                    pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                                    attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                                    total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                                    cp90MetersData: cp90Data.defectiveMetersData,
                                    replacedPercent: cp90Data.replacedPercent,
                                    pendingPercent: cp90Data.pendingPercent
                                },
                            )
                        }

                        object.tableDataTechnical = []

                        let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

                        if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'T & D',
                                    monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                                    progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                                    tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                                    tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                                    tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                                    tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                                },
                            )
                        }

                        let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'Recovery',
                                    monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                                    progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                                    recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                                    recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                                    recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                                    recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                                }
                            )
                        }

                        let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'AT & C',
                                    monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                                    progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                                    atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                                    atcMonthlyDifferenceData: atcMonthlyData.incDec,
                                    atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                                    atcProgressiveDifferenceData: atcProgressiveData.incDec,
                                },
                            )
                        }
                        responseUniqueCodesWithName.push(object);
                    })
                    setChildrenList(responseUniqueCodesWithName)
                }

            } catch (error) {
                console.error('Error in drillUp:', error);
            }
            setViewBackdrop(false)
        }
        fetchData()

    }

    const drillDown = (previtem) => {
        const fetchData = async () => {
            setViewBackdrop(true)
            try {
                //#region Customer Services
                let newConnectionResult = await NewConnectionsStats(previtem.code)
                let complaintsResult = await ComplaintsStats(previtem.code)
                let cp90Result = await DefectiveCP90DashboardStatsDrillDown(token, previtem.code)
                //#endregion

                //#region Technical Commercial Losses
                let tdMonthlyLossesResult = await MonthlyTDLossesDashboardStatsDrillDown(token, previtem.code, previtem.level);
                let tdProgressiveLossesResult = await ProgressiveTDLossesDashboardStatsDrillDown(token, previtem.code)
                let recoveryMonthlyResult = await MonthlyRecoveryDashboardStatsDrillDown(token, previtem.code)
                let recoveryProgressiveResult = await ProgressiveRecoveryDashboardStatsDrillDown(token, previtem.code)
                let atcMonthlyResult = await MonthlyATCDashboardStatsDrillDown(token, previtem.code)
                let atcProgressiveResult = await ProgressiveATCDashboardStatsDrillDown(token, previtem.code)
                //#endregion

                if (previtem.level === 3) {
                    let allDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
                    let responseUniqueCodesWithName = [];
                    allDivisions.forEach(item => {
                        let object = {};
                        object.code = item;
                        let obj = {}
                        if (subdivisionsFromLocalStorage) {
                            obj = subdivisionsFromLocalStorage.find(itm => itm.divisionCode === item);
                        }
                        object.name = obj ? obj.divisionName : null;
                        object.level = parseInt(previtem.level) + 1;
                        object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
                        object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
                        object.drillFunction = drillDown
                        object.tableDataServices = []

                        let ncData = newConnectionResult.find((item) => item.officeCode == object.code)
                        if (ncData) {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: ncData.Ripe,
                                unripe: ncData.Unripe,
                                total: ncData.Ripe + ncData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let complaintData = complaintsResult.find((item) => item.OfficeCode == object.code)
                        if (complaintData) {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: complaintData.Ripe,
                                unripe: complaintData.Unripe,
                                total: complaintData.Ripe + complaintData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
                        if (cp90Data) {
                            object.tableDataServices.push(
                                {
                                    type: 'Defective Meter (CP-90)',
                                    pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                                    attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                                    total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                                    cp90MetersData: cp90Data.defectiveMetersData,
                                    replacedPercent: cp90Data.replacedPercent,
                                    pendingPercent: cp90Data.pendingPercent
                                },
                            )
                        }

                        object.tableDataTechnical = []

                        let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

                        if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'T & D',
                                    monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                                    progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                                    tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                                    tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                                    tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                                    tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                                },
                            )
                        }

                        let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'Recovery',
                                    monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                                    progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                                    recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                                    recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                                    recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                                    recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                                }
                            )
                        }

                        let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'AT & C',
                                    monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                                    progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                                    atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                                    atcMonthlyDifferenceData: atcMonthlyData.incDec,
                                    atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                                    atcProgressiveDifferenceData: atcProgressiveData.incDec,
                                },
                            )
                        }
                        responseUniqueCodesWithName.push(object);
                    })
                    setChildrenList(responseUniqueCodesWithName)
                }
                if (previtem.level === 4) {
                    let allSubDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
                    let responseUniqueCodesWithName = [];
                    allSubDivisions.forEach(item => {
                        let object = {};
                        object.code = item;
                        let obj = {}
                        if (subdivisionsFromLocalStorage) {
                            obj = subdivisionsFromLocalStorage.find(itm => itm.subDivisionCode === item);
                        }
                        object.name = obj ? obj.subDivisionName : null;
                        object.level = parseInt(previtem.level) + 1;
                        object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
                        object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
                        object.childrenIcon = null
                        object.drillFunction = drillDown
                        object.tableDataServices = []

                        let ncData = newConnectionResult.find((item) => item.officeCode == object.code)
                        if (ncData) {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: ncData.Ripe,
                                unripe: ncData.Unripe,
                                total: ncData.Ripe + ncData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let complaintData = complaintsResult.find((item) => item.OfficeCode == object.code)
                        if (complaintData) {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: complaintData.Ripe,
                                unripe: complaintData.Unripe,
                                total: complaintData.Ripe + complaintData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
                        if (cp90Data) {
                            object.tableDataServices.push(
                                {
                                    type: 'Defective Meter (CP-90)',
                                    pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                                    attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                                    total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                                    cp90MetersData: cp90Data.defectiveMetersData,
                                    replacedPercent: cp90Data.replacedPercent,
                                    pendingPercent: cp90Data.pendingPercent
                                },
                            )
                        }

                        object.tableDataTechnical = []

                        let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

                        if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'T & D',
                                    monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                                    progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                                    tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                                    tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                                    tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                                    tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                                },
                            )
                        }

                        let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'Recovery',
                                    monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                                    progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                                    recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                                    recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                                    recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                                    recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                                }
                            )
                        }

                        let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'AT & C',
                                    monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                                    progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                                    atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                                    atcMonthlyDifferenceData: atcMonthlyData.incDec,
                                    atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                                    atcProgressiveDifferenceData: atcProgressiveData.incDec,
                                },
                            )
                        }
                        responseUniqueCodesWithName.push(object);
                    })
                    setChildrenList(responseUniqueCodesWithName)
                }

            } catch (error) {
                console.error('Error in drillDown:', error);
            }
            setViewBackdrop(false)
        }
        fetchData()
    }

    //#region states
    const [parentDetails, setParentDetails] = useState(
        {
            name: '',
            code: null,
            level: 2,
            trendingIcon: trendingDownIcn,
            overallPerformance: null,
            function: drillUp,
            customerServices: [
                {
                    titleA: 'Defective Meter',
                    titleB: '(CP-90)',
                    descriptiveText: 'Installed out of',
                    pending: 0,
                    total: 0,
                    type: 'services'
                }
            ],
            technicalCommercial: [
                {
                    titleA: 'T & D',
                    titleB: 'Monthly',
                    value: null,
                    type: 'losses',
                    incDec: 'positive'
                },
                {
                    titleA: 'T & D',
                    titleB: 'Progressive',
                    value: null,
                    type: 'losses',
                    incDec: 'negetive'
                },
                {
                    titleA: 'Recovery',
                    titleB: 'Monthly',
                    value: null,
                    type: 'losses',
                    incDec: 'positive'
                },
                {
                    titleA: 'Recovery',
                    titleB: 'Progressive',
                    value: null,
                    type: 'losses',
                    incDec: 'negetive'
                },
                {
                    titleA: 'AT & C',
                    titleB: 'Monthly',
                    value: null,
                    type: 'losses',
                    incDec: 'positive'
                },
                {
                    titleA: 'AT & C',
                    titleB: 'Progressive',
                    value: null,
                    type: 'losses',
                    incDec: 'positive'
                },
            ]
        });
    const [childrenList, setChildrenList] = useState([])
    const [tDMonthlyLossData, setTDMonthlyLossData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [tDProgressiveLossData, setTDProgressiveLossData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [tDMonthlyLossDifferenceData, setTDMonthlyLossDifferenceData] = useState([])
    const [tDProgressiveLossDifferenceData, setTDProgressiveLossDifferenceData] = useState([])
    const [recoveryMonthlyData, setRecoveryMonthlyData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [recoveryProgressiveData, setRecoveryProgressiveData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [recoveryMonthlyDifferenceData, setRecoveryMonthlyDifferenceData] = useState([]);
    const [recoveryProgressiveDifferenceData, setRecoveryProgressiveDifferenceData] = useState([]);
    const [aTCMonthlyData, setATCMonthlyData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [aTCProgressiveData, setATCProgressiveData] = useState({
        'firstYear': [],
        'secondYear': []
    })
    const [aTCMonthlyDifferenceData, setATCMonthlyDifferenceData] = useState([])
    const [aTCProgressiveDifferenceData, setATCProgressiveDifferenceData] = useState([])
    const [tDMonthlyChart, setTDMonthlyChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0,
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        tooltip: {
            pointFormat: ' {series.name}: <b>{point.y}%</b>'
        },
        colors: [ // Custom colors for the pie slices
            '#FD8A8A', // Slice 2 color
            '#FF3131', // Slice 1 color
            // Add more colors as needed
        ],
        yAxis: {
            title: {
                text: 'T & D Loss (%age)'
            }
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        series: [{
            name: '2022',
            data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
        }, {
            name: '2023',
            data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
        }]
    })
    const [tDProgressiveChart, setTDProgressiveChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: ' transparent',
            height: 300,
            padding: 0,
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        yAxis: {
            title: {
                text: 'T & D Loss (%age)'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        series: [{
            name: '2022',
            data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
        }, {
            name: '2023',
            data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
        }],
        colors: [ // Custom colors for the pie slices
            '#FD8A8A', // Slice 2 color
            '#FF3131', // Slice 1 color
            // Add more colors as needed
        ],
    })
    const [recoveryMonthlyChart, setRecoveryMonthlyChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        colors: [ // Custom colors for the pie slices
            '#88D6B5', // Slice 1 color
            '#12AE6C', // Slice 2 color
            // Add more colors as needed
        ],
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        yAxis: {
            title: {
                text: 'Recovery (%age)'
            }
        },
        series: [{
            name: '2022',
            data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
        }, {
            name: '2023',
            data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
        }]
    })
    const [recoveryProgressiveChart, setRecoveryProgressiveChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        yAxis: {
            title: {
                text: 'Recovery (%age)'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        series: [{
            name: '2022',
            data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
        }, {
            name: '2023',
            data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
        }],
        colors: [ // Custom colors for the pie slices
            '#88D6B5', // Slice 1 color
            '#12AE6C', // Slice 2 color
            // Add more colors as needed
        ],
    })
    const [aTCMonthlyChart, setATCMonthlyChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        yAxis: {
            title: {
                text: 'AT & C Loss (%age)'
            }
        },
        series: [{
            name: '2022',
            data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
        }, {
            name: '2023',
            data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
        }],
        colors: [ // Custom colors for the pie slices
            '#F6D3A9', // Slice 2 color
            '#FFC03D', // Slice 1 color
            // Add more colors as needed
        ],
    })
    const [aTCProgressiveChart, setATCProgressiveChart] = useState({
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            height: 300,
            padding: 0
        },
        title: {
            text: '',
            style: {
                fontSize: '14px'
            }
        },
        xAxis: {
            categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
        },
        credits: {
            enabled: false
        },
        yAxis: {
            title: {
                text: 'AT & C Loss (%age)'
            }
        },
        legend: {
            align: 'left',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
            x: 0,
            y: 0,
            symbolRadius: 2,
        },
        plotOptions: {
            column: {
                borderRadius: '25%'
            }
        },
        series: [{
            name: '2022',
            data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
        }, {
            name: '2023',
            data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
        }],
        colors: [ // Custom colors for the pie slices
            '#F6D3A9', // Slice 2 color
            '#FFC03D', // Slice 1 color
            // Add more colors as needed
        ],
    })
    //#endregion

    //#region functions

    const MonthlyTDLossesDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedMonthlyLossData: []
            }

            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/billTNDLoses", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data
                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)
                        if (separateYearData.firstYear) {
                            separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        }
                        if (separateYearData.secondYear) {
                            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                                const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        }

                        setTDMonthlyLossData(separateYearData)
                        let incDec = []
                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
                            incDec.push(objectValue)
                        }
                        setTDMonthlyLossDifferenceData(incDec)
                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
                            }
                        ];
                        const updatedTDMonthlyChart = {
                            ...tDMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };
                        setTDMonthlyChart(updatedTDMonthlyChart);
                        let index = incDec.length - 1
                        let aggregateTDMonthly = 0

                        if (incDec.length > 1) {
                            aggregateTDMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateTDMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[0] = {
                                ...newTechnicalCommercial[0],
                                value: aggregateTDMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            newState.name = getName(officeCode != 10 ? officeCode.toString().length === 7 ? officeCode.toString().slice(0, 4) : officeCode.toString() : '15', subdivisionsFromLocalStorage);
                            newState.code = officeCode === 10 ? 15 : officeCode;
                            newState.level = getParentLevel(hierarchy);
                            newState.trendingIcon = getTrendingIcon(1, 2) === true ? trendingDownIcn : trendingUpIcn;

                            return newState;
                        });
                        //#endregion

                        //#region children logic 
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedMonthlyLossData = transformData(childrenObjects)

                        childrenTransformedMonthlyLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedMonthlyLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })

                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedMonthlyLossData = childrenTransformedMonthlyLossData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveTDLossesDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedProgressiveLossData: []
            }
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/billTNDLosesProgressive", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                            let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })

                        setTDProgressiveLossData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setTDProgressiveLossDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
                            }
                        ];

                        const updatedTDProgressiveChart = {
                            ...tDMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };

                        setTDProgressiveChart(updatedTDProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateTDProgressive = 0
                        if (incDec.length > 1) {
                            aggregateTDProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateTDProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[1] = {
                                ...newTechnicalCommercial[1],
                                value: aggregateTDProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });
                        //#endregion

                        //#region children logic 

                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedProgressiveLossData = transformData(childrenObjects)

                        childrenTransformedProgressiveLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedProgressiveLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })

                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedProgressiveLossData = childrenTransformedProgressiveLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const MonthlyRecoveryDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedMonthlyRecoveryData: []
            }
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/monthlyRecovry", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let separateYearData = separateObjectsByYear(parentObjects)

                        if (separateYearData.firstYear) {
                            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };
                                return roundedObj;
                            })
                        }

                        if (separateYearData.secondYear) {
                            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })
                        }

                        setRecoveryMonthlyData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
                            incDec.push(objectValue)
                        }


                        setRecoveryMonthlyDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            }
                        ];


                        const updatedRecoveryMonthlyChart = {
                            ...recoveryMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setRecoveryMonthlyChart(updatedRecoveryMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateRecoveryMonthly = 0

                        if (incDec.length > 1) {
                            aggregateRecoveryMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateRecoveryMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[2] = {
                                ...newTechnicalCommercial[2],
                                value: aggregateRecoveryMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });
                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedMonthlyRecoveryData = transformData(childrenObjects)

                        childrenTransformedMonthlyRecoveryData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedMonthlyRecoveryData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedMonthlyRecoveryData = childrenTransformedMonthlyRecoveryData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveRecoveryDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedProgressiveRecoveryData: []
            }
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/progressiveRecovry", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic 
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)
                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        setRecoveryProgressiveData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
                            incDec.push(objectValue)
                        }


                        setRecoveryProgressiveDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            }
                        ];


                        const updatedRecoveryProgressiveChart = {
                            ...recoveryProgressiveChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };

                        setRecoveryProgressiveChart(updatedRecoveryProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateRecoveryProgressive = 0;
                        if (incDec.length > 1) {
                            aggregateRecoveryProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateRecoveryProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[3] = {
                                ...newTechnicalCommercial[3],
                                value: aggregateRecoveryProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });

                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedProgressiveRecoveryData = transformData(childrenObjects)

                        childrenTransformedProgressiveRecoveryData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedProgressiveRecoveryData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedProgressiveRecoveryData = childrenTransformedProgressiveRecoveryData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const MonthlyATCDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedAtcMonthlyLossData: []
            }
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/monthlyATC", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        setATCMonthlyData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setATCMonthlyDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
                            }
                        ];


                        const updatedATCMonthlyChart = {
                            ...aTCMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setATCMonthlyChart(updatedATCMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateATCMonthly = 0

                        if (incDec.length > 1) {
                            aggregateATCMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateATCMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[4] = {
                                ...newTechnicalCommercial[4],
                                value: aggregateATCMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedAtcMonthlyLossData = transformData(childrenObjects)

                        childrenTransformedAtcMonthlyLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedAtcMonthlyLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedAtcMonthlyLossData = childrenTransformedAtcMonthlyLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveATCDashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedAtcProgressiveLossData: []
            }
            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/progressiveATC", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)

                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        setATCProgressiveData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setATCProgressiveDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
                            }
                        ];


                        const updatedATCProgressiveChart = {
                            ...aTCProgressiveChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setATCProgressiveChart(updatedATCProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateATCProgressive = 0

                        if (incDec.length > 1) {
                            aggregateATCProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateATCProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[5] = {
                                ...newTechnicalCommercial[5],
                                value: aggregateATCProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            newState.overallPerformance = aggregateATCProgressive;
                            newState.trendingIcon = aggregateATCProgressive > 0 ? trendingDownIcn : trendingUpIcn
                            return newState;
                        });

                        dispatch(updatePerformance(aggregateATCProgressive))

                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedAtcProgressiveLossData = transformData(childrenObjects)

                        childrenTransformedAtcProgressiveLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedAtcProgressiveLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedAtcProgressiveLossData = childrenTransformedAtcProgressiveLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const NewConnectionsStats = async (officeCode) => {
        setViewBackdrop(true)
        let servicesResult = []
        if (officeCode) {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "officeCode": officeCode == "10" ? "15" : officeCode
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "dashBoard/childernStatsOfficeWise", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        servicesResult = result.data
                    }
                })
                .catch((error) => console.error(error));
        }
        setViewBackdrop(false)
        return servicesResult
    }
    const ComplaintsStats = async (officeCode) => {
        setViewBackdrop(true)
        let complaintsResult = []
        if (officeCode) {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "officeCode": officeCode == "10" ? "15" : officeCode
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "dashBoard/childernwiseComplaintsStatsStatusWise", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        complaintsResult = result.data
                    }
                })
                .catch((error) => console.error(error));
        }
        setViewBackdrop(false)
        return complaintsResult
    }
    const DefectiveCP90DashboardStats = async (token, officeCode, hierarchy) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                childrenTransformedCP90Data: []
            }

            var formdata = new FormData();
            if (hierarchy != 51) {
                if (officeCode == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", officeCode);
                }
            } else {
                formdata.append("officeCode", officeCode.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/defectiveMetersCP90Summary", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region children logic 
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let childrenTransformedCP90Data = groupByOfficeCode(childrenObjects)
                        childrenTransformedCP90Data.forEach((officeData) => {
                            // Calculate totals for each property
                            let total = {
                                monthYear: officeData.defectiveMetersData.monthYear,
                                officeCode: officeData.defectiveMetersData[0].officeCode,
                                trfCat: 'Total',
                                curMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                                lastMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                                prograsive: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
                                pending: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
                                mcoEffected: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
                            };
                            officeData.defectiveMetersData.push(total);
                        });

                        childrenTransformedCP90Data.forEach((officeData) => {
                            let totalObject = officeData.defectiveMetersData[officeData.defectiveMetersData.length - 1]
                            let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
                            let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)
                            officeData.replacedPercent = parseFloat(replacedPercent)
                            officeData.pendingPercent = parseFloat(pendingPercent)
                        })

                        childrenTransformedCP90Data = childrenTransformedCP90Data.map((officeData) => {
                            officeData.defectiveMetersData = officeData.defectiveMetersData.map((item) => {
                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear,
                                    curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                                    lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                                    prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                                    pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                                    mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
                                };
                                return roundedObj
                            })
                            return officeData
                        })

                        returnObject.childrenTransformedCP90Data = childrenTransformedCP90Data
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }

    const MonthlyTDLossesDashboardStatsDrillDown = async (token, code, level) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedMonthlyLossData: []
            }

            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/billTNDLoses", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)
                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                            let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })
                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })
                        setTDMonthlyLossData(separateYearData)
                        let incDec = []
                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
                            incDec.push(objectValue)
                        }
                        setTDMonthlyLossDifferenceData(incDec)
                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
                            }
                        ];
                        const updatedTDMonthlyChart = {
                            ...tDMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };
                        setTDMonthlyChart(updatedTDMonthlyChart);

                        let index = incDec.length - 1

                        let aggregateTDMonthly = 0

                        if (incDec.length > 1) {
                            aggregateTDMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateTDMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }
                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[0] = {
                                ...newTechnicalCommercial[0],
                                value: aggregateTDMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            newState.name = getName(code.toString(), subdivisionsFromLocalStorage);
                            newState.code = code;
                            newState.level = level;
                            newState.trendingIcon = getTrendingIcon(1, 2) === true ? trendingDownIcn : trendingUpIcn;

                            return newState;
                        });
                        //#endregion

                        //#region children logic 
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedMonthlyLossData = transformData(childrenObjects)

                        childrenTransformedMonthlyLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedMonthlyLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })

                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedMonthlyLossData = childrenTransformedMonthlyLossData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveTDLossesDashboardStatsDrillDown = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedProgressiveLossData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/billTNDLosesProgressive", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                            let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })

                        setTDProgressiveLossData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setTDProgressiveLossDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
                            }
                        ];

                        const updatedTDProgressiveChart = {
                            ...tDMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };

                        setTDProgressiveChart(updatedTDProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateTDProgressive = 0
                        if (incDec.length > 1) {
                            aggregateTDProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateTDProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }
                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[1] = {
                                ...newTechnicalCommercial[1],
                                value: aggregateTDProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });
                        //#endregion

                        //#region children logic 

                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedProgressiveLossData = transformData(childrenObjects)

                        childrenTransformedProgressiveLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedProgressiveLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })

                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedProgressiveLossData = childrenTransformedProgressiveLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const MonthlyRecoveryDashboardStatsDrillDown = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedMonthlyRecoveryData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/monthlyRecovry", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };
                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        setRecoveryMonthlyData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
                            incDec.push(objectValue)
                        }


                        setRecoveryMonthlyDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            }
                        ];


                        const updatedRecoveryMonthlyChart = {
                            ...recoveryMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setRecoveryMonthlyChart(updatedRecoveryMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateRecoveryMonthly = 0

                        if (incDec.length > 1) {
                            aggregateRecoveryMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateRecoveryMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[2] = {
                                ...newTechnicalCommercial[2],
                                value: aggregateRecoveryMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });
                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedMonthlyRecoveryData = transformData(childrenObjects)

                        childrenTransformedMonthlyRecoveryData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedMonthlyRecoveryData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedMonthlyRecoveryData = childrenTransformedMonthlyRecoveryData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveRecoveryDashboardStatsDrillDown = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedProgressiveRecoveryData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/progressiveRecovry", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic 
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)
                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        setRecoveryProgressiveData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
                            incDec.push(objectValue)
                        }


                        setRecoveryProgressiveDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            }
                        ];


                        const updatedRecoveryProgressiveChart = {
                            ...recoveryProgressiveChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };

                        setRecoveryProgressiveChart(updatedRecoveryProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateRecoveryProgressive = 0;
                        if (incDec.length > 1) {
                            aggregateRecoveryProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateRecoveryProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[3] = {
                                ...newTechnicalCommercial[3],
                                value: aggregateRecoveryProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });

                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedProgressiveRecoveryData = transformData(childrenObjects)

                        childrenTransformedProgressiveRecoveryData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedProgressiveRecoveryData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedProgressiveRecoveryData = childrenTransformedProgressiveRecoveryData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const MonthlyATCDashboardStatsDrillDown = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedAtcMonthlyLossData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/monthlyATC", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        setATCMonthlyData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setATCMonthlyDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
                            }
                        ];


                        const updatedATCMonthlyChart = {
                            ...aTCMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setATCMonthlyChart(updatedATCMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateATCMonthly = 0

                        if (incDec.length > 1) {
                            aggregateATCMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateATCMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }
                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[4] = {
                                ...newTechnicalCommercial[4],
                                value: aggregateATCMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedAtcMonthlyLossData = transformData(childrenObjects)

                        childrenTransformedAtcMonthlyLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedAtcMonthlyLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedAtcMonthlyLossData = childrenTransformedAtcMonthlyLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveATCDashboardStatsDrillDown = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedAtcProgressiveLossData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/progressiveATC", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)

                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        setATCProgressiveData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setATCProgressiveDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
                            }
                        ];


                        const updatedATCProgressiveChart = {
                            ...aTCProgressiveChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setATCProgressiveChart(updatedATCProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateATCProgressive = 0

                        if (incDec.length > 1) {
                            aggregateATCProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateATCProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            // newState.overallPerformance = 35;
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[5] = {
                                ...newTechnicalCommercial[5],
                                value: aggregateATCProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            newState.overallPerformance = aggregateATCProgressive;
                            newState.trendingIcon = aggregateATCProgressive > 0 ? trendingDownIcn : trendingUpIcn
                            return newState;
                        });

                        dispatch(updatePerformance(aggregateATCProgressive))

                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedAtcProgressiveLossData = transformData(childrenObjects)

                        childrenTransformedAtcProgressiveLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedAtcProgressiveLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedAtcProgressiveLossData = childrenTransformedAtcProgressiveLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }

    const DefectiveCP90DashboardStatsDrillDown = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                childrenTransformedCP90Data: []
            }

            var formdata = new FormData();
            if (hierarchy != 51) {
                if (code == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", code);
                }
            } else {
                formdata.append("officeCode", code.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/defectiveMetersCP90Summary", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region children logic 
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let childrenTransformedCP90Data = groupByOfficeCode(childrenObjects)
                        childrenTransformedCP90Data.forEach((officeData) => {
                            // Calculate totals for each property
                            let total = {
                                monthYear: officeData.defectiveMetersData.monthYear,
                                officeCode: officeData.defectiveMetersData[0].officeCode,
                                trfCat: 'Total',
                                curMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                                lastMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                                prograsive: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
                                pending: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
                                mcoEffected: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
                            };
                            officeData.defectiveMetersData.push(total);
                        });

                        childrenTransformedCP90Data.forEach((officeData) => {
                            let totalObject = officeData.defectiveMetersData[officeData.defectiveMetersData.length - 1]
                            let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
                            let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)
                            officeData.replacedPercent = parseFloat(replacedPercent)
                            officeData.pendingPercent = parseFloat(pendingPercent)
                        })

                        childrenTransformedCP90Data = childrenTransformedCP90Data.map((officeData) => {
                            officeData.defectiveMetersData = officeData.defectiveMetersData.map((item) => {
                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear,
                                    curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                                    lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                                    prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                                    pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                                    mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
                                };
                                return roundedObj
                            })
                            return officeData
                        })

                        returnObject.childrenTransformedCP90Data = childrenTransformedCP90Data
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }

    const MonthlyTDLossesDashboardStatsDrillUp = async (token, code, level) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedMonthlyLossData: []
            }

            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/billTNDLoses", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)
                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                            let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })
                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })
                        setTDMonthlyLossData(separateYearData)
                        let incDec = []
                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
                            incDec.push(objectValue)
                        }
                        setTDMonthlyLossDifferenceData(incDec)
                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
                            }
                        ];
                        const updatedTDMonthlyChart = {
                            ...tDMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };
                        setTDMonthlyChart(updatedTDMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateTDMonthly = 0

                        if (incDec.length > 1) {
                            aggregateTDMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateTDMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }
                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[0] = {
                                ...newTechnicalCommercial[0],
                                value: aggregateTDMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            newState.name = getName(code.toString(), subdivisionsFromLocalStorage);
                            newState.code = code;
                            newState.level = level;
                            newState.trendingIcon = getTrendingIcon(1, 2) === true ? trendingDownIcn : trendingUpIcn;

                            return newState;
                        });
                        //#endregion

                        //#region children logic 
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedMonthlyLossData = transformData(childrenObjects)

                        childrenTransformedMonthlyLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedMonthlyLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })

                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedMonthlyLossData = childrenTransformedMonthlyLossData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveTDLossesDashboardStatsDrillUp = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedProgressiveLossData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/billTNDLosesProgressive", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                            let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                            };

                            return roundedObj;
                        })

                        setTDProgressiveLossData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setTDProgressiveLossDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
                            }
                        ];

                        const updatedTDProgressiveChart = {
                            ...tDMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };

                        setTDProgressiveChart(updatedTDProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateTDProgressive = 0
                        if (incDec.length > 1) {
                            aggregateTDProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateTDProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }
                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[1] = {
                                ...newTechnicalCommercial[1],
                                value: aggregateTDProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });
                        //#endregion

                        //#region children logic 

                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedProgressiveLossData = transformData(childrenObjects)

                        childrenTransformedProgressiveLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                                    unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                                    totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                                    tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                                    unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedProgressiveLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })

                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedProgressiveLossData = childrenTransformedProgressiveLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const MonthlyRecoveryDashboardStatsDrillUp = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedMonthlyRecoveryData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/monthlyRecovry", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };
                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        setRecoveryMonthlyData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
                            incDec.push(objectValue)
                        }


                        setRecoveryMonthlyDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            }
                        ];


                        const updatedRecoveryMonthlyChart = {
                            ...recoveryMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setRecoveryMonthlyChart(updatedRecoveryMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateRecoveryMonthly = 0

                        if (incDec.length > 1) {
                            aggregateRecoveryMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateRecoveryMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[2] = {
                                ...newTechnicalCommercial[2],
                                value: aggregateRecoveryMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });
                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedMonthlyRecoveryData = transformData(childrenObjects)

                        childrenTransformedMonthlyRecoveryData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedMonthlyRecoveryData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedMonthlyRecoveryData = childrenTransformedMonthlyRecoveryData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveRecoveryDashboardStatsDrillUp = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedProgressiveRecoveryData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/progressiveRecovry", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic 
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)
                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                            };

                            return roundedObj;
                        })

                        setRecoveryProgressiveData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
                            incDec.push(objectValue)
                        }


                        setRecoveryProgressiveDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
                            }
                        ];


                        const updatedRecoveryProgressiveChart = {
                            ...recoveryProgressiveChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };

                        setRecoveryProgressiveChart(updatedRecoveryProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateRecoveryProgressive = 0;
                        if (incDec.length > 1) {
                            aggregateRecoveryProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateRecoveryProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[3] = {
                                ...newTechnicalCommercial[3],
                                value: aggregateRecoveryProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });

                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedProgressiveRecoveryData = transformData(childrenObjects)

                        childrenTransformedProgressiveRecoveryData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                    difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                                    percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedProgressiveRecoveryData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedProgressiveRecoveryData = childrenTransformedProgressiveRecoveryData
                        //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const MonthlyATCDashboardStatsDrillUp = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedAtcMonthlyLossData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/monthlyATC", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let separateYearData = separateObjectsByYear(parentObjects)


                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        setATCMonthlyData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setATCMonthlyDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
                            }
                        ];


                        const updatedATCMonthlyChart = {
                            ...aTCMonthlyChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setATCMonthlyChart(updatedATCMonthlyChart);

                        let index = incDec.length - 1
                        let aggregateATCMonthly = 0

                        if (incDec.length > 1) {
                            aggregateATCMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateATCMonthly = parseFloat(incDec[index].value).toFixed(2)
                        }
                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[4] = {
                                ...newTechnicalCommercial[4],
                                value: aggregateATCMonthly
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            return newState;
                        });

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedAtcMonthlyLossData = transformData(childrenObjects)

                        childrenTransformedAtcMonthlyLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedAtcMonthlyLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedAtcMonthlyLossData = childrenTransformedAtcMonthlyLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }
    const ProgressiveATCDashboardStatsDrillUp = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                allChildrenIncDec: [],
                childrenTransformedAtcProgressiveLossData: []
            }
            var formdata = new FormData();
            formdata.append("officeCode", code);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/progressiveATC", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region parent logic
                        let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
                        let separateYearData = separateObjectsByYear(parentObjects)

                        separateYearData.firstYear = separateYearData.firstYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        separateYearData.secondYear = separateYearData.secondYear.map((item) => {

                            const roundedObj = {
                                ...item,
                                monthYear: item.monthYear.slice(0, 3),
                                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                            };

                            return roundedObj;
                        })

                        setATCProgressiveData(separateYearData)

                        let incDec = []

                        for (let i = 0; i < separateYearData.secondYear.length; i++) {
                            let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
                            incDec.push(objectValue)
                        }

                        setATCProgressiveDifferenceData(incDec)

                        let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
                        const currentYear = new Date().getFullYear();
                        let seriesData = [
                            {
                                name: (currentYear - 1).toString(),
                                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
                            },
                            {
                                name: currentYear.toString(),
                                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
                            }
                        ];


                        const updatedATCProgressiveChart = {
                            ...aTCProgressiveChart,
                            xAxis: {
                                categories: categories
                            },
                            series: seriesData
                        };


                        setATCProgressiveChart(updatedATCProgressiveChart);

                        let index = incDec.length - 1
                        let aggregateATCProgressive = 0

                        if (incDec.length > 1) {
                            aggregateATCProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
                        } else {
                            aggregateATCProgressive = parseFloat(incDec[index].value).toFixed(2)
                        }

                        setParentDetails(prevState => {
                            const newState = { ...prevState };
                            // newState.overallPerformance = 35;
                            const newTechnicalCommercial = [...newState.technicalCommercial];
                            newTechnicalCommercial[5] = {
                                ...newTechnicalCommercial[5],
                                value: aggregateATCProgressive
                            };
                            // Update the technicalCommercial array in the newState
                            newState.technicalCommercial = newTechnicalCommercial;
                            newState.overallPerformance = aggregateATCProgressive;
                            newState.trendingIcon = aggregateATCProgressive > 0 ? trendingDownIcn : trendingUpIcn
                            return newState;
                        });

                        dispatch(updatePerformance(aggregateATCProgressive))

                        //#endregion

                        //#region child logic
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

                        let childrenTransformedAtcProgressiveLossData = transformData(childrenObjects)

                        childrenTransformedAtcProgressiveLossData.map((item) => {
                            item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })

                            item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear.slice(0, 3),
                                    compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                                    recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                                };

                                return roundedObj;
                            })
                        })

                        let allChildrenIncDec = []
                        childrenTransformedAtcProgressiveLossData.forEach((item) => {
                            let childObj = { code: item.officeCode }
                            let childIncDec = []
                            for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                                childIncDec.push(objectValue)
                            }
                            childObj.incDec = childIncDec
                            allChildrenIncDec.push(childObj)
                        })
                        returnObject.allChildrenIncDec = allChildrenIncDec
                        returnObject.childrenTransformedAtcProgressiveLossData = childrenTransformedAtcProgressiveLossData
                        //#endregion

                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }

    const DefectiveCP90DashboardStatsDrillUp = async (token, code) => {
        setViewBackdrop(true)
        try {
            let returnObject = {
                childrenTransformedCP90Data: []
            }

            var formdata = new FormData();
            if (hierarchy != 51) {
                if (code == 10) {
                    formdata.append("officeCode", 15);
                } else {
                    formdata.append("officeCode", code);
                }
            } else {
                formdata.append("officeCode", code.toString().slice(0, 4));
            }
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "dashBoard/defectiveMetersCP90Summary", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let allData = result.data

                        //#region children logic 
                        let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
                        let childrenTransformedCP90Data = groupByOfficeCode(childrenObjects)
                        childrenTransformedCP90Data.forEach((officeData) => {
                            // Calculate totals for each property
                            let total = {
                                monthYear: officeData.defectiveMetersData.monthYear,
                                officeCode: officeData.defectiveMetersData[0].officeCode,
                                trfCat: 'Total',
                                curMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                                lastMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                                prograsive: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
                                pending: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
                                mcoEffected: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
                            };
                            officeData.defectiveMetersData.push(total);
                        });

                        childrenTransformedCP90Data.forEach((officeData) => {
                            let totalObject = officeData.defectiveMetersData[officeData.defectiveMetersData.length - 1]
                            let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
                            let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)
                            officeData.replacedPercent = parseFloat(replacedPercent)
                            officeData.pendingPercent = parseFloat(pendingPercent)
                        })

                        childrenTransformedCP90Data = childrenTransformedCP90Data.map((officeData) => {
                            officeData.defectiveMetersData = officeData.defectiveMetersData.map((item) => {
                                const roundedObj = {
                                    ...item,
                                    monthYear: item.monthYear,
                                    curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                                    lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                                    prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                                    pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                                    mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
                                };
                                return roundedObj
                            })
                            return officeData
                        })

                        returnObject.childrenTransformedCP90Data = childrenTransformedCP90Data
                        //   //#endregion
                    }
                })
                .catch(error => console.log('error', error));
            return returnObject
        }
        catch (e) {
            console.log(e, 'Dashboard API issue')
        }
        setViewBackdrop(false)
    }

    //#endregion

    //#endregion

    //#region useEffects

    useEffect(() => {
        setViewBackdrop(true)

        const fetchData = async () => {
            try {
                //#region Technical & Commercial 
                let tdMonthlyLossesResult = await MonthlyTDLossesDashboardStats(token, officeCode, hierarchy);
                let tdProgressiveLossesResult = await ProgressiveTDLossesDashboardStats(token, officeCode, hierarchy)
                let recoveryMonthlyResult = await MonthlyRecoveryDashboardStats(token, officeCode, hierarchy)
                let recoveryProgressiveResult = await ProgressiveRecoveryDashboardStats(token, officeCode, hierarchy)
                let atcMonthlyResult = await MonthlyATCDashboardStats(token, officeCode, hierarchy)
                let atcProgressiveResult = await ProgressiveATCDashboardStats(token, officeCode, hierarchy)
                //#endregion

                //#region Customer Services
                let newConnectionResult = await NewConnectionsStats(officeCode)
                let complaintsResult = await ComplaintsStats(officeCode)
                let cp90Result = await DefectiveCP90DashboardStats(token, officeCode, hierarchy)
                //#endregion

                if (hierarchy === 1 || hierarchy === 2) {
                    let allCircles = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
                    let responseUniqueCodesWithName = [];
                    allCircles.forEach(item => {
                        let object = {};
                        object.code = item;
                        let obj = {}
                        if (subdivisionsFromLocalStorage) {
                            obj = subdivisionsFromLocalStorage.find(itm => itm.circleCode === item);
                        }
                        object.name = obj ? obj.circleName : null;
                        object.level = getChildLevel(hierarchy);
                        object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
                        object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
                        object.drillFunction = drillDown
                        object.tableDataServices = []

                        let ncData = newConnectionResult.find((item) => item.officeCode == object.code)
                        if (ncData) {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: ncData.Ripe,
                                unripe: ncData.Unripe,
                                total: ncData.Ripe + ncData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let complaintData = complaintsResult.find((item) => item.OfficeCode == object.code)
                        if (complaintData) {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: complaintData.Ripe,
                                unripe: complaintData.Unripe,
                                total: complaintData.Ripe + complaintData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
                        if (cp90Data) {
                            object.tableDataServices.push(
                                {
                                    type: 'Defective Meter (CP-90)',
                                    pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                                    attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                                    total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                                    cp90MetersData: cp90Data.defectiveMetersData,
                                    replacedPercent: cp90Data.replacedPercent,
                                    pendingPercent: cp90Data.pendingPercent
                                },
                            )
                        }

                        object.tableDataTechnical = []

                        let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

                        if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'T & D',
                                    monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                                    progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                                    tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                                    tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                                    tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                                    tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                                },
                            )
                        }

                        let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'Recovery',
                                    monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                                    progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                                    recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                                    recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                                    recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                                    recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                                }
                            )
                        }

                        let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'AT & C',
                                    monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                                    progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                                    atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                                    atcMonthlyDifferenceData: atcMonthlyData.incDec,
                                    atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                                    atcProgressiveDifferenceData: atcProgressiveData.incDec,
                                },
                            )
                        }

                        responseUniqueCodesWithName.push(object);
                    })
                    setChildrenList(responseUniqueCodesWithName)
                }
                if (hierarchy === 3) {
                    let allDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
                    let responseUniqueCodesWithName = [];
                    allDivisions.forEach(item => {
                        let object = {};
                        object.code = item;
                        let obj = {}
                        if (subdivisionsFromLocalStorage) {
                            obj = subdivisionsFromLocalStorage.find(itm => itm.divisionCode === item);
                        }
                        object.name = obj ? obj.divisionName : null;
                        object.level = getChildLevel(hierarchy);
                        object.trendingIcon = trendingDownIcn
                        object.drillFunction = drillDown
                        object.tableDataServices = []

                        let ncData = newConnectionResult.find((item) => item.officeCode == object.code)
                        if (ncData) {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: ncData.Ripe,
                                unripe: ncData.Unripe,
                                total: ncData.Ripe + ncData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let complaintData = complaintsResult.find((item) => item.OfficeCode == object.code)
                        if (complaintData) {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: complaintData.Ripe,
                                unripe: complaintData.Unripe,
                                total: complaintData.Ripe + complaintData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
                        if (cp90Data) {
                            object.tableDataServices.push(
                                {
                                    type: 'Defective Meter (CP-90)',
                                    pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                                    attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                                    total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                                    cp90MetersData: cp90Data.defectiveMetersData,
                                    replacedPercent: cp90Data.replacedPercent,
                                    pendingPercent: cp90Data.pendingPercent
                                },
                            )
                        }

                        object.tableDataTechnical = []

                        let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

                        if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'T & D',
                                    monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                                    progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                                    tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                                    tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                                    tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                                    tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                                },
                            )
                        }

                        let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'Recovery',
                                    monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                                    progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                                    recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                                    recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                                    recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                                    recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                                }
                            )
                        }

                        let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'AT & C',
                                    monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                                    progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                                    atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                                    atcMonthlyDifferenceData: atcMonthlyData.incDec,
                                    atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                                    atcProgressiveDifferenceData: atcProgressiveData.incDec,
                                },
                            )
                        }
                        responseUniqueCodesWithName.push(object);
                    })
                    setChildrenList(responseUniqueCodesWithName)
                }
                if (hierarchy === 4 || hierarchy === 51) {
                    let allSubDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
                    console.log(allSubDivisions, 'printing all subdiviison')
                    let responseUniqueCodesWithName = [];
                    allSubDivisions.forEach(item => {
                        let object = {};
                        object.code = item;
                        let obj = {}
                        if (subdivisionsFromLocalStorage) {
                            obj = subdivisionsFromLocalStorage.find(itm => itm.subDivisionCode === item);
                        }
                        object.name = obj ? obj.subDivisionName : null;
                        object.level = getChildLevel(hierarchy);
                        object.trendingIcon = trendingDownIcn
                        object.drillFunction = drillDown
                        object.tableDataServices = []
                        let ncData = newConnectionResult.find((item) => item.officeCode == object.code)
                        if (ncData) {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: ncData.Ripe,
                                unripe: ncData.Unripe,
                                total: ncData.Ripe + ncData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'New Connections',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let complaintData = complaintsResult.find((item) => item.OfficeCode == object.code)
                        if (complaintData) {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: complaintData.Ripe,
                                unripe: complaintData.Unripe,
                                total: complaintData.Ripe + complaintData.Unripe,
                            })
                        } else {
                            object.tableDataServices.push({
                                type: 'Complaints',
                                ripe: 0,
                                unripe: 0,
                                total: 0,
                            })
                        }

                        let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
                        if (cp90Data) {
                            object.tableDataServices.push(
                                {
                                    type: 'Defective Meter (CP-90)',
                                    pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                                    attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                                    total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                                    cp90MetersData: cp90Data.defectiveMetersData,
                                    replacedPercent: cp90Data.replacedPercent,
                                    pendingPercent: cp90Data.pendingPercent
                                },
                            )
                        }

                        object.tableDataTechnical = []

                        let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

                        if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'T & D',
                                    monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                                    progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                                    tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                                    tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                                    tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                                    tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                                },
                            )
                        }

                        let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
                        let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'Recovery',
                                    monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                                    progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                                    recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                                    recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                                    recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                                    recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                                }
                            )
                        }

                        let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
                        let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
                        let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
                        let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

                        if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
                            object.tableDataTechnical.push(
                                {
                                    type: 'AT & C',
                                    monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                                    progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                                    atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                                    atcMonthlyDifferenceData: atcMonthlyData.incDec,
                                    atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                                    atcProgressiveDifferenceData: atcProgressiveData.incDec,
                                },
                            )
                        }
                        responseUniqueCodesWithName.push(object);
                    })
                    setChildrenList(responseUniqueCodesWithName)
                }
            } catch (error) {
                console.error('Error in useLayoutEffect:', error);
            }
            setViewBackdrop(false)
        }
        fetchData()
    }, [])

    //#endregion

    //#endregion

    return (
        <>
            <Box className="form-box">
                <div className='cfc-dashboard' style={{ flexDirection: 'row' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <Suspense fallback={<ConsumerBaseLoading />}>
                            <ConsumerBase officeCode={officeCode == "10" ? "15" : officeCode} showTechnicalCommercial={true} />
                        </Suspense>
                        <Suspense fallback={<JuniorCardLoading />}>
                            <JuniorCard officeCode={officeCode == "10" ? "15" : officeCode} updateOfficeCode={updateOfficeCode} childrenList={childrenList} parent={parentDetails} />
                        </Suspense>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <Suspense fallback={<TechnicalAndCommercialLoading />}>
                            <TechnicalAndCommercial
                                technicalCommercialprop={parentDetails.technicalCommercial}
                                tDMonthlyLossData={tDMonthlyLossData}
                                tDMonthlyChart={tDMonthlyChart}
                                tDMonthlyLossDifferenceData={tDMonthlyLossDifferenceData}
                                tDProgressiveLossData={tDProgressiveLossData}
                                tDProgressiveChart={tDProgressiveChart}
                                tDProgressiveLossDifferenceData={tDProgressiveLossDifferenceData}
                                recoveryMonthlyData={recoveryMonthlyData}
                                recoveryMonthlyChart={recoveryMonthlyChart}
                                recoveryMonthlyDifferenceData={recoveryMonthlyDifferenceData}
                                recoveryProgressiveData={recoveryProgressiveData}
                                recoveryProgressiveChart={recoveryProgressiveChart}
                                recoveryProgressiveDifferenceData={recoveryProgressiveDifferenceData}
                                aTCMonthlyData={aTCMonthlyData}
                                aTCMonthlyChart={aTCMonthlyChart}
                                aTCMonthlyDifferenceData={aTCMonthlyDifferenceData}
                                aTCProgressiveData={aTCProgressiveData}
                                aTCProgressiveChart={aTCProgressiveChart}
                                aTCProgressiveDifferenceData={aTCProgressiveDifferenceData}
                            />
                        </Suspense>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <Suspense fallback={<CurrentBillingChartLoading />}>
                                <CurrentBillingChart officeCode={officeCode == "10" ? "15" : officeCode} />
                            </Suspense>
                            <Suspense fallback={<CurrentCollectionDashboardLoading />}>
                                <CurrentCollectionDashboard officeCode={officeCode == "10" ? "15" : officeCode} />
                            </Suspense>
                        </div>
                    </div>
                </div>
            </Box>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default HierarchicalDashboard